import { render, staticRenderFns } from "./AdvertiserTermsAndConditions.vue?vue&type=template&id=6edb988c"
import script from "./AdvertiserTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./AdvertiserTermsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports